(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npCommonGridSetting', ['$document', function ($document) {
        return {
            restrict: 'E',
            controller: ['$scope', 'broadcastService','localStorageService', controller],
            scope: {
                columnsConfiguration: '=',
                color: '@',
                gridSettingKey: '@',
                columnNotRemove: '=',
                showInfoCol: '='
            },
            templateUrl: '/app/shared/grid/commonGridSetting.html',
            replace: true,
            link: function (scope, element, attr) {
                scope.showGridSettingContextMenu = false;
                $('body').click(function (event) {
                    var isClickedElementChildOfPopup = element
                      .find(event.target)
                      .length > 0;

                    if (isClickedElementChildOfPopup)
                        return;
                    scope.showGridSettingContextMenu = false;
                });
            }
        };
    }]);

    function controller($scope, broadcastService, localStorageService) {
        $scope.translation = globalResources;
        $scope.optionalColumns = angular.copy($scope.columnsConfiguration);

        $scope.initialize = function () {
            loadColumnsConfiguration();
        }

        function loadColumnsConfiguration() {
            var localStorage = localStorageService.getItem($scope.gridSettingKey);
            if (localStorage != undefined) {
                var objectLocalStorage = JSON.parse(localStorage);
                $scope.columnsConfiguration = objectLocalStorage;
            } else {
                $scope.columnsConfiguration = angular.copy($scope.optionalColumns);
            }
        }

        $scope.updateGrid = function ($event) {
            localStorageService.setItem($scope.gridSettingKey, JSON.stringify($scope.columnsConfiguration));
            $scope.showGridSettingContextMenu = !$scope.showGridSettingContextMenu;

            //var gridSetting = getGridSetting($scope.gridSettingKey);
            broadcastService($scope.gridSettingKey, {
                value: $scope.columnsConfiguration
            });
        };

        $scope.checkItem = function (column) {
            if (column.id != $scope.columnNotRemove) {
                column.coldefault = !column.coldefault;
            }
        };

        $scope.checkAll = function () {
            $scope.columnsConfiguration.forEach(function (item) {
                if (item.id != $scope.columnNotRemove) {
                    item.coldefault = true;
                }
            });
        };

        $scope.uncheckAll = function () {
            $scope.columnsConfiguration.forEach(function (item) {
                if (item.id != $scope.columnNotRemove) {
                    item.coldefault = false;
                }
            });
        };

        $scope.showPopup = function () {
            $scope.showGridSettingContextMenu = !$scope.showGridSettingContextMenu;
            if ($scope.showGridSettingContextMenu) {
                loadColumnsConfiguration();
            }
        };
    }

})();